var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
/* HOOK */
export function useDeprecation(config) {
    var oldThing = config.oldThing, newThing = config.newThing, link = config.link;
    var when = 'when' in config ? typeof config.when !== 'undefined' : true;
    React.useLayoutEffect(function () {
        if (when &&
            ['test', 'development'].indexOf(process.env.NODE_ENV || '') >= 0) {
            var notice = oldThing + " is deprecated";
            var recommendation = newThing ? ", please use " + newThing : '';
            console.warn("" + notice + recommendation, link !== null && link !== void 0 ? link : '');
        }
    }, [when, newThing, oldThing, link]);
}
/* DECORATOR */
export function withDeprecation(config) {
    return function (Component) {
        return function DeprecationComponent(props) {
            useDeprecation(config);
            return React.createElement(Component, __assign({}, props));
        };
    };
}
//# sourceMappingURL=Deprecation.js.map